/* Relocate the existing Trustpilot display only; retain its scripts, settings and iframe. */
(() => {
  const businessUnit = '662c30461f7b950cd886bdca';
  const moveReviews = () => {
    const target = document.getElementById('fsk-bottom-reviews');
    if (!target) return;
    document.querySelectorAll(`.trustpilot-widget[data-businessunit-id="${businessUnit}"]`).forEach(widget => {
      if (widget.parentElement !== target) target.appendChild(widget);
    });
    const heading = target.querySelector('[data-review-heading]');
    if (heading) heading.hidden = !target.querySelector('.trustpilot-widget');
  };
  moveReviews();
  const observer = new MutationObserver(moveReviews);
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', moveReviews);
})();
